// extracted by mini-css-extract-plugin
module.exports = {"CarouselArrow":"RightArrow-module--CarouselArrow--3w0L0","ArrowSvgRight":"RightArrow-module--ArrowSvgRight--1MPjb"};